import {
  Action,
  OperationType,
  Position,
  ThemeLoad,
  WarningType
} from '../../../dispatcher/Types';

export const loadThemes: Action = [{
  moduleName: 'ThemeService',
  name: 'getThemes',
  mappingName: 'themes',
  type: OperationType.addOperationData
}, {
  persistent: ['themes'],
  type: OperationType.addPersistentData
}];

export const functionalCookiesMissingWarningClosed: Action = [{
  data: {
    functionalCookiesWarningDisplayed: false
  },
  type: OperationType.data
}];

export const functionalCookiesMissingWarning: Action = [{
  condition: '!{functionalCookiesWarningDisplayed}',
  conditionOperations: [{
    data: {
      functionalCookiesWarningDisplayed: true
    },
    persistent: ['functionalCookiesWarningDisplayed'],
    type: OperationType.data
  }, {
    className: 'sm info',
    items: [{
      operations: [{
        name: 'functionalCookiesMissingWarningClosed',
        type: OperationType.action
      }, {
        condition: '!{cookiesMissing}',
        conditionOperations: [{
          data: {
            forceThemeChange: true
          },
          type: OperationType.data
        }, {
          args: ['theme'],
          isPromise: true,
          handleError: true,
          moduleName: 'ThemeService',
          name: 'forceChangeTheme'
        }],
        type: OperationType.conditional
      }],
      btnName: 'FunctionalCookiesMissing.close',
      btnConfig: {
        pos: Position.end
      }
    }, {
      operations: [{
        name: 'functionalCookiesMissingWarningClosed',
        type: OperationType.action
      }, {
        consent: true,
        type: OperationType.redirect
      }],
      btnName: 'FunctionalCookiesMissing.goToConsentPage',
      btnConfig: {
        themeColor: 'primary',
        pos: Position.end
      }
    }],
    text: 'FunctionalCookiesMissing.text',
    title: 'FunctionalCookiesMissing.title',
    warningType: WarningType.warning,
    type: OperationType.warning
  }],
  type: OperationType.conditional
}];

export const changeTheme: Action = [{
  moduleName: 'CookieManager',
  name: 'hasFunctionalCookie',
  type: OperationType.addOperationData
}, {
  condition: '{hasFunctionalCookie} || {firstLoadApp}',
  conditionOperations: [{
    args: ['theme'],
    isPromise: true,
    handleError: true,
    moduleName: 'ThemeService',
    name: 'changeTheme'
  }, {
    condition: '{changeTheme.themeRejected}',
    conditionOperations: [{
      name: 'setDefaultTheme',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    moduleName: 'ThemeService',
    name: 'isThemeServiceInitialized',
    type: OperationType.addOperationData
  }, {
    condition: '{isThemeServiceInitialized}',
    conditionOperations: [{
      name: 'functionalCookiesMissingWarning',
      type: OperationType.action
    }],
    elseOperations: [{
      data: {
        forceThemeChange: true
      },
      type: OperationType.data
    }, {
      args: ['theme'],
      isPromise: true,
      handleError: true,
      moduleName: 'ThemeService',
      name: 'forceChangeTheme'
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const setDefaultTheme: Action = [{
  load: ThemeLoad.init,
  type: OperationType.theme
}, {
  data: {
    template: {
      bind: {
        // extract first theme from themes json
        theme: '{themes}[Object.keys({themes})[0]].name'
      }
    }
  },
  load: ThemeLoad.change,
  type: OperationType.theme
}];
